import { Markdown } from '@mews/framework';
import { LocalizedText } from '@mews/framework/localization';
import { useToggle } from '@mews/framework/utils';
import { Dialog, Link } from '@optimus-web/core';

interface MarkdownLinkProps {
    markdown: string;
    textKey: Mews.TextKey;
}

export const MarkdownLink = ({ markdown, textKey }: MarkdownLinkProps) => {
    const [isMarkdownOpen, toggleMarkdownOpen] = useToggle();

    const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        toggleMarkdownOpen();
    };

    const title = <LocalizedText textKey={textKey} />;

    return (
        <>
            <Dialog active={isMarkdownOpen} onClose={toggleMarkdownOpen} title={title}>
                <Markdown content={markdown} />
            </Dialog>
            <Link as="button" type="button" inherit onClick={handleLinkClick}>
                {title}
            </Link>
        </>
    );
};
